import "./ListCivics.module.css";
import Header from "@/reusable_sections/Header";
import CandidatesList6 from "./sections/CandidatesList6";
import Footer from "@/reusable_sections/Footer";
export default function ListCivicsPage() {
  return <div className='min-h-screen flex flex-col'>
      <Header />
      <CandidatesList6 />
      <Footer />
    </div>;
}